import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { initiateClaimErrorSelector, setInitiateClaimError } from '@redux/slices/claimStatusSlice'

type UseCreateClaimRecordStatusReturn = {
  isError?: boolean
  setCreateClaimRecordError: (isError: boolean) => void
}

export const useCreateClaimRecordStatus = (): UseCreateClaimRecordStatusReturn => {
  const dispatch = useDispatch()
  const isError = useSelector(initiateClaimErrorSelector)

  const setCreateClaimRecordError = useCallback(
    (error: boolean) => {
      dispatch(setInitiateClaimError(error))
    },
    [dispatch]
  )

  return {
    isError,
    setCreateClaimRecordError,
  }
}
